ixModuleRouting(
    "impactx.userlist",
    {
        "/userlist": {
            template: "<ixa-user-list></ixa-user-list>",
            templateUrl: "modules/userlist/templates/userlist.html",
            controller: "UserListCtrl",
            controllerAs: "userListCtrl",
            process: "UserLists",
            workspace: "admin",
        },
        "/userrightlist": {
            template: "<ixa-user-rights-list></ixa-user-rights-list>",
            templateUrl: "modules/userlist/templates/userightslist.html",
            controller: "UserRightsListCtrl",
            controllerAs: "userRightsListCtrl",
            process: "UserLists",
            workspace: "admin",
        },
    },
    ["ngRoute", "impactx.list"]
);
